import '../pro_platform/index';



// WEBPACK FOOTER //
// ./app/javascript/packs/pro_platform.js